import { useModel as _useModel, mergeModels as _mergeModels, defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, mergeProps as _mergeProps, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx } from "vue"

import {useGlobalSetting} from "@/lib/utils";


export default /*@__PURE__*/_defineComponent({
  __name: 'isSafetySelect',
  props: /*@__PURE__*/_mergeModels({
  prependIcon: {
    type: String,
    default: '',
    required: false,
  },
  onChange: {
    type: Function,
    required: false,
  },
  dense: {
    type: Boolean,
    required: false,
    default: false,
  }
}, {
    "modelValue": {},
    "modelModifiers": {},
  }),
  emits: ["update:modelValue"],
  setup(__props) {


const globalSetting = useGlobalSetting();

const model = _useModel(__props, "modelValue");

const props = __props

const items = [
  {
    key: "Alle",
    description: "alle mit Safety und ohne Safety",
    value: ""
  },
  {
    key: "Mit Safety",
    description: "alle mit Safety",
    value: "true"
  }, {
    key: "Kein Safety",
    description: "alle mit Safety",
    value: "false"
  },
]

return (_ctx: any,_cache: any) => {
  const _component_v_list_item = _resolveComponent("v-list-item")!
  const _component_v_select = _resolveComponent("v-select")!

  return (_openBlock(), _createBlock(_component_v_select, {
    modelValue: model.value,
    "onUpdate:modelValue": [
      _cache[0] || (_cache[0] = ($event: any) => ((model).value = $event)),
      _cache[1] || (_cache[1] = ($event: any) => (props.onChange?.()))
    ],
    label: "Safety",
    items: items,
    "item-title": "key",
    "item-value": "value",
    "prepend-icon": props.prependIcon,
    "bg-color": model.value == 'true' ? '#fff000' : '',
    dense: props.dense,
    density: props.dense ? 'compact' : 'default',
    "hide-details": props.dense,
    style: {"width":"100%"},
    variant: _unref(globalSetting).globalTextVariant
  }, {
    item: _withCtx(({ props: itemProps, item }) => [
      (item.value == 'true')
        ? (_openBlock(), _createBlock(_component_v_list_item, _mergeProps({
            key: 0,
            "base-color": "#ffd000",
            subtitle: item.raw.description
          }, itemProps), null, 16, ["subtitle"]))
        : (_openBlock(), _createBlock(_component_v_list_item, _mergeProps({
            key: 1,
            subtitle: item.raw.description
          }, itemProps), null, 16, ["subtitle"]))
    ]),
    _: 1
  }, 8, ["modelValue", "prepend-icon", "bg-color", "dense", "density", "hide-details", "variant"]))
}
}

})